import React from 'react';

import { ReactComponent as Icon } from 'assets/img/vectors/rating/rating-up.svg';

const RatingUp = (props) => (
   <Icon { ...props }/>
);

export default RatingUp;
